var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg68(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M8.25152 14.9059C11.9787 14.8564 14.961 11.7234 14.9127 7.90808C14.8643 4.0928 11.8036 1.04004 8.07636 1.08955C4.34914 1.13906 1.36685 4.27209 1.41522 8.08738C1.46358 11.9027 4.5243 14.9554 8.25152 14.9059Z",
    fill: "#753CBE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25152 14.9059C11.9787 14.8564 14.961 11.7234 14.9127 7.90808C14.8643 4.0928 11.8036 1.04004 8.07636 1.08955C4.34914 1.13906 1.36685 4.27209 1.41522 8.08738C1.46358 11.9027 4.5243 14.9554 8.25152 14.9059Z",
    fill: "white",
    stroke: "#753CBE",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.41606 7.99484C8.41553 7.94379 8.40022 7.89404 8.37206 7.8519C8.3439 7.80976 8.30415 7.77711 8.25786 7.7581C8.21157 7.73909 8.16081 7.73457 8.112 7.7451C8.06319 7.75564 8.01854 7.78076 7.98368 7.81728C7.94883 7.85381 7.92535 7.9001 7.91621 7.95029C7.90707 8.00049 7.91268 8.05233 7.93234 8.09925C7.952 8.14618 7.98481 8.18608 8.02663 8.21391C8.06845 8.24173 8.1174 8.25623 8.16728 8.25557C8.23402 8.25468 8.29769 8.22674 8.34433 8.17786C8.39097 8.12898 8.41676 8.06316 8.41606 7.99484V7.99484Z",
    fill: "#753CBE",
    stroke: "#753CBE",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.09521 2.20117L8.10612 3.06159",
    stroke: "#753CBE",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.23096 12.8669L8.24187 13.7274",
    stroke: "#753CBE",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7987 7.88971L12.9575 7.90088",
    stroke: "#753CBE",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3.37913 8.02839L2.53857 8.03955",
    stroke: "#753CBE",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0586 3.01758L10.627 3.75641",
    stroke: "#753CBE",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M5.70948 12.1716L5.27785 12.9105",
    stroke: "#753CBE",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0864 5.15863L12.3519 5.57753",
    stroke: "#753CBE",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M3.98436 10.3508L3.24981 10.7697",
    stroke: "#753CBE",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0006 10.9232L12.2788 10.4807",
    stroke: "#753CBE",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M4.0582 5.44745L3.33643 5.00562",
    stroke: "#753CBE",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9092 12.9989L10.5 12.2463",
    stroke: "#753CBE",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83696 3.68184L5.42773 2.92993",
    stroke: "#753CBE",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M8.38189 14.6595C6.37659 14.6463 4.80869 13.6851 3.39869 12.4045C1.98869 11.124 1.59003 9.33593 1.21414 7.59678C1.67742 6.11005 1.66021 4.39228 3.08612 3.13034C3.06736 1.64991 0.41169 11.0224 2.41699 11.0356L8.42433 7.88081L8.38189 14.6595Z",
    fill: "#753CBE",
    fillOpacity: 0.6
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg68);
export default __webpack_public_path__ + "static/media/6_8.1ad067b713f4367506b0b071428231fa.svg";
export { ForwardRef as ReactComponent };